<template>
  <div>
    <v-breadcrumbs :items="items" divider="/"></v-breadcrumbs>
    <v-tabs
      class="v-tabs--pill primary white--text"
      hide-slider
      active-class="white primary--text"
      v-model="activeTab"
      show-arrows
      dark
      background-color="transparent"
      centered
      touchless
      icons-and-text
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.name"
        :to="{ name: tab.name, params: { id: $route.params['id'] } }"
      >
        {{ tab.text }}
      </v-tab>
    </v-tabs>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/equipment-list`)"
        >
          <v-icon>mdi-cogs</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("dashboard.buttons.gotoEquipment") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeTab: "",
      tabs: [
        {
          name: "EquipmentProfile/Dashboard",
          text: this.$t("dashboard.dashboard")
        },
        { name: "EquipmentProfile/Ranges", text: this.$t("dashboard.ranges") },
        {
          name: "EquipmentProfile/OperationalValues",
          text: this.$t("dashboard.operationalValues")
        },
        {
          name: "EquipmentProfile/Charts",
          text: this.$t("dashboard.graphics")
        },
        {
          name: "EquipmentProfile/Inspections",
          text: this.$t("dashboard.inspections")
        },
        {
          name: "EquipmentProfile/ReliabilityList",
          text: this.$t("dashboard.reliability")
        },
        {
          name: "EquipmentProfile/Planner",
          text: this.$t("dashboard.planner")
        },
        {
          name: "EquipmentProfile/RepairLog",
          text: this.$t("dashboard.repairLog")
        },
        {
          name: "EquipmentProfile/Documents",
          text: this.$t("dashboard.documents")
        }
      ]
    };
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    items() {
      return this.equipmentProfile?.equipTag
        ? [
            {
              text: this.$t("dashboard.assetList"),
              disabled: false,
              to: "/assets"
            },
            {
              text: this.equipmentProfile.equipTag,
              disabled: true
            }
          ]
        : [];
    }
  }
};
</script>

<style></style>
